<script>
	export let propsName, propsProfile;
	import Body from "./components/body/Body.svelte";
	import Heading from "./components/heading/Heading.svelte";
</script>

<main class="h-screen mx-auto md:w-4/5 lg:w-3/5 px-4 md:px-0">
	<Heading name={propsName} imgProfile={propsProfile} />
	<Body />
</main>

<style>

</style>